import { render, staticRenderFns } from "./notification-detail-phone-reception-request.vue?vue&type=template&id=56c86a22&"
import script from "./notification-detail-phone-reception-request.vue?vue&type=script&lang=js&"
export * from "./notification-detail-phone-reception-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports